import React, { useEffect, useState } from "react";
import { Box, Button, Alert, Typography } from "@mui/material";

import {
  getExpenseSignatures,
  signExpenseAsEmployee,
  signExpenseAsManager,
} from "../../../../api/Expenses/expenseSignaturesApi";

const ExpenseSignaturesTab = ({ documentId, status, onSigned }) => {
  const [signatures, setSignatures] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadSignatures = async () => {
    try {
      setLoading(true);
      const data = await getExpenseSignatures(documentId);
      setSignatures(data);
    } catch (e) {
      setError("No se pudieron cargar las firmas");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSignatures();
  }, [documentId]);

  const handleEmployeeSign = async () => {
    try {
      setError(null);
      await signExpenseAsEmployee(documentId);
      await loadSignatures();
      onSigned?.();
    } catch (e) {
      const msg = e?.response?.data?.error || "Error al firmar como empleado";

      setError(msg);
    }
  };

  const handleManagerSign = async () => {
    try {
      setError(null);
      await signExpenseAsManager(documentId);
      await loadSignatures();
      onSigned?.();
    } catch (e) {
      const msg = e?.response?.data?.error || "Error al firmar como manager";

      setError(msg);
    }
  };

  return (
    <Box>
      {error && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Typography sx={{ mb: 2 }}>
        Estado del documento: <b>{status}</b>
      </Typography>

      {status === "draft" && (
        <Button variant="contained" onClick={handleEmployeeSign}>
          FIRMAR COMO EMPLEADO
        </Button>
      )}

      {status === "signed_employee" && (
        <Button
          variant="contained"
          color="secondary"
          onClick={handleManagerSign}
        >
          FIRMAR COMO MANAGER
        </Button>
      )}
    </Box>
  );
};

export default ExpenseSignaturesTab;
